import React from "react";
import IExamIntroductionState, { IExamIntroductionProps } from "./ExamIntroduction.models";
import ExamService from "../../../services/exam/ExamService";
import ExamResultService from "../../../services/exam/ExamResultService";
import ExamTimeViewModal from "../exam-view/exam-time-view-modal/ExamTimeViewModal";
import moment from 'jalali-moment';
import BrowserAlert from "../../shared/browser-alert/BrowserAlert";

export default class ExamIntroduction extends React.PureComponent<IExamIntroductionProps, IExamIntroductionState> {
    examService: ExamService;
    examResultService: ExamResultService;
    examTimeViewModal: React.RefObject<ExamTimeViewModal>;
    constructor(props: any) {
        super(props);
        this.examService = new ExamService();
        this.examResultService = new ExamResultService();
        this.state = { examDetails: {}, loading: false, startExam: {}, coursesGroup: [] }
        this.examTimeViewModal = React.createRef<ExamTimeViewModal>();
    }

    componentDidMount(): void {
        this.setState({ loading: true })

        this.examService.getExamIntroduction(Number(this.props.examId)).then((response) => {
            this.setState({
                examDetails: response
            }, () => this.mapQuestion())
        }).finally(() => this.setState({ loading: false }))
    }

    mapQuestion() {
        let tempQuestions = this.state.coursesGroup

        if (this.state.examDetails.structure != undefined && this.state.examDetails.structure != null) {
            var groups: { questions: any[], orderId: number, title: string }[] = this.state.examDetails.structure.map((structureItem, index) => {
                return {
                    orderId: index,
                    title: structureItem.groupTitle,
                    questions: this.state.examDetails.questionsInformation?.filter(question => structureItem.courseIds.indexOf(question.courseId) != -1) ?? []
                }
            })

            let from = 0
            groups.map((group) => {
                tempQuestions.push({
                    courseTitle: group.title ?? null,
                    orderId: group.orderId,
                    from: from == 0 ? 1 : from,
                    to: group.questions.length + from,
                    totalQuestions: group.questions.length,
                })
                from += group.questions.length
                return tempQuestions
            })
        } else {
            const groupByQuestions = this.state.examDetails.questionsInformation?.reduce((group: any, question) => {
                const { courseTitle } = question;

                if (courseTitle !== null) {
                    group[courseTitle] = group[courseTitle] ?? [];
                    group[courseTitle].push(question);
                    return group;
                } else {
                    return question
                }
            }, {});

            let from = 0
            Object.entries(groupByQuestions).map((item: any) => {
                tempQuestions.push({
                    courseTitle: item[0] ?? null,
                    orderId: this.state.examDetails.questionsInformation?.filter(question => question.courseTitle == item[0])[0].courseId,
                    from: from == 0 ? 1 : from,
                    to: item[1].length + from,
                    totalQuestions: item[1].length,
                })
                from += item[1].length
                return tempQuestions
            })

            if (this.state.examDetails.courseIds != undefined && this.state.examDetails.courseIds != null && this.state.examDetails.courseIds) {
                // @ts-ignore
                tempQuestions = tempQuestions.sort((a, b) => this.state.examDetails.courseIds.indexOf(a.orderId) - this.state.examDetails.courseIds.indexOf(b.orderId));
            }
        }

        this.setState({ coursesGroup: tempQuestions })
        this.forceUpdate()
    }

    startExam(examId: number) {
        let self = this;
        const { examDetails } = this.state;

        self.state.startExam.studentExamId = examId;

        // eslint-disable-next-line no-restricted-globals
        if (confirm('آیا از شرکت در این آزمون مطمئن هستید؟')) {

            self.examResultService.startExam(self.state.startExam).then(function (response) {
                if (response && response.status === 200) {
                    window.location.href = `/Exam?examId=${examId}&examResultId=${response.data.examId}`;
                }
                else if (response && response.data.message !== undefined && response.data.message !== null) {
                    self.context.showNotify({ badge: "danger", title: "نا موفق", description: response.data.message });
                }
                else if (self.state.examDetails.examDateTimeFrom && self.state.examDetails.examDateTimeTo && self.state.examDetails.examTime)
                    self.examTimeViewModal.current?.openModal(self.props.examId as number, examDetails.examDateTimeFrom as string, examDetails.examDateTimeTo as string, examDetails.examTime as string)
                else
                    self.examTimeViewModal.current?.openModal(self.props.examId as number, undefined, undefined, undefined, examDetails.examTime ? `زمان برگزاری آزمون ساعت ${examDetails.examTime} می باشد.` : 'امکان دسترسی به آزمون وجود ندارد')

            })
        }
    }

    render(): React.ReactNode {
        const { loading, examDetails, coursesGroup } = this.state

        return !loading && <>
            <div className="tk-card question-view-area exam-introduction-view dropdown-list"
                style={{ height: "85vh" }}>
                <div className="col-12 font-bold pb-5 pt-5 text-center">
                    {examDetails.title}
                </div>
                <div className="col-12 user-info">
                    <div className="tk-inline">
                        <div className="col-6 font-sm notspace">
                            <label> مدت زمان آزمون </label>
                        </div>
                        <div className="col-6 notspace font-sm text-orange text-left">
                            <label>{examDetails.examDuration} دقیقه</label>
                        </div>
                    </div>
                    <div className="tk-inline">
                        <div className="col-6 font-sm notspace">
                            <label>رشته</label>
                        </div>
                        <div className="col-6 notspace font-sm text-orange text-left">
                            <label>{examDetails.studentFieldTitle}</label>
                        </div>
                    </div>
                    <div className="tk-inline">
                        <div className="col-6 font-sm notspace">
                            <label>پایه</label>
                        </div>
                        <div className="col-6 notspace font-sm text-orange text-left">
                            <label>{examDetails.studentBaseTitles}</label>
                        </div>
                    </div>
                    {
                        examDetails.examDateTimeFrom &&
                        <div className="tk-inline">
                            <div className="col-4 font-sm notspace">
                                <label> تاریخ برگزاری </label>
                            </div>
                            <div className="col-8 notspace font-sm text-orange text-left">
                                <label>{examDetails.examDateTimeTo && moment(examDetails.examDateTimeTo).locale('fa').format('YYYY/MM/DD')}</label>
                                <label style={{ padding: '0 2px' }}> {!examDetails.examDateTimeFrom ? "از" : "تا"} </label>
                                <label>{examDetails.examDateTimeFrom && moment(examDetails.examDateTimeFrom, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</label>
                            </div>
                        </div>
                    }
                </div>
                {
                    coursesGroup.length > 0 && <div className="col-12 tk-padding-bottom tk-padding-top">
                        <div className="section student-performance-table-area">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>مواد امتحانی</th>
                                        <th>تعداد سوالات</th>
                                        <th>از</th>
                                        <th>تا</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        coursesGroup.map((course, key) => {
                                            return <tr key={key}>
                                                <td>{course.courseTitle}</td>
                                                <td>{course.totalQuestions}</td>
                                                <td>{course.from}</td>
                                                <td>{course.to}</td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
                <div className="col-12 tk-padding-bottom">
                    <button className="btn btn-success tk-full-width" onClick={() => { this.startExam(this.props.examId as number) }}>شروع آزمون</button>
                </div>
                <div className="col-12 user-info">
                    <div className="tk-inline">
                        <div className="col-12 font-sm notspace">
                            <label className="font-bold px-1">ملاحظات: </label>
                            <label>{examDetails.totalQuestions} تا سوال {examDetails.examDuration} دقیقه</label>
                            <BrowserAlert />
                        </div>
                    </div>
                </div>
            </div>
            <ExamTimeViewModal ref={this.examTimeViewModal} />
        </>
    }
}